export default "__VITE_ASSET__3a7bf73f__"